/**
 * The route tree.
 *
 * Code based rather than file generated, on purpose: eight agents are writing route files in
 * parallel and a generated tree file is a merge conflict on every commit. The contract is
 * simple and every route file already follows it:
 *
 *   export const Route = createRoute({
 *     getParentRoute: () => shellRoute,   // or rootRoute for login and lock
 *     path: '/orders',
 *     component: OrdersPage,
 *   });
 *
 * Replace a stub file wholesale, keep the export name `Route` and the `path`, and nothing
 * here has to change. Adding a genuinely new URL is the one case that needs an edit to this
 * file, and that is a deliberate speed bump: the URL table in DESIGN.md is a contract and
 * deep links are shared in Slack.
 */
import { Route as rootRoute } from '@/routes/__root';
import { Route as shellRoute } from '@/routes/_shell';
import { Route as forbiddenRoute } from '@/routes/forbidden';
import { Route as homeRoute } from '@/routes/index';
import { Route as inboxRoute } from '@/routes/inbox';

import { Route as loginRoute } from '@/routes/login/index';
import { Route as lockRoute } from '@/routes/lock/index';

import { Route as settingsControlsRoute } from '@/routes/settings/index';
import { Route as settingsUsersRoute } from '@/routes/settings/users';
import { Route as settingsAlertsRoute } from '@/routes/settings/alerts';
import { Route as settingsSystemRoute } from '@/routes/settings/system';
import { Route as settingsAuditRoute } from '@/routes/settings/audit';
import { Route as settingsChangelogRoute } from '@/routes/settings/changelog';

// A5 exports components rather than routes; the adapter is the only place that knows.
import { ordersRoute, orderDetailRoute } from './ordersAdapter';

import { Route as stockRoute } from '@/routes/stock/index';
import { Route as stockLedgerRoute } from '@/routes/stock/$productId.ledger';
import { Route as stockInboundRoute } from '@/routes/stock/inbound';
import { Route as stockInboundPoRoute } from '@/routes/stock/inbound.$poId';
import { Route as stockSuppliersRoute } from '@/routes/stock/suppliers';
import { Route as stockPricingRoute } from '@/routes/stock/pricing';
import { Route as legendRoute } from '@/routes/legend/index';

import { Route as benchRoute } from '@/routes/bench/index';

import { Route as customersRoute } from '@/routes/customers/index';
import { Route as customerDetailRoute } from '@/routes/customers/$customerKey';

import { Route as supportRoute } from '@/routes/support/index';
import { Route as supportHandoffsRoute } from '@/routes/support/handoffs';
import { Route as supportMacrosRoute } from '@/routes/support/macros';
import { Route as supportTicketRoute } from '@/routes/support/$ref';

import { Route as financeRoute } from '@/routes/finance/index';
import { Route as financeForecastRoute } from '@/routes/finance/forecast';
import { Route as financeLedgersRoute } from '@/routes/finance/ledgers';
import { Route as financePnlRoute } from '@/routes/finance/pnl';

import { Route as growthRoute } from '@/routes/growth/index';
import { Route as growthChannelsRoute } from '@/routes/growth/channels';
import { Route as growthEmailRoute } from '@/routes/growth/email';
import { Route as growthReferralsRoute } from '@/routes/growth/referrals';
import { Route as growthPartnersRoute } from '@/routes/growth/partners';

export const routeTree = rootRoute.addChildren([
  loginRoute,
  lockRoute,
  forbiddenRoute,
  shellRoute.addChildren([
    homeRoute,
    inboxRoute,

    ordersRoute,
    orderDetailRoute,

    stockRoute,
    stockInboundRoute,
    stockInboundPoRoute,
    stockSuppliersRoute,
    stockPricingRoute,
    stockLedgerRoute,
    legendRoute,

    benchRoute,

    customersRoute,
    customerDetailRoute,

    supportRoute,
    supportHandoffsRoute,
    supportMacrosRoute,
    supportTicketRoute,

    financeRoute,
    financeForecastRoute,
    financeLedgersRoute,
    financePnlRoute,

    growthRoute,
    growthChannelsRoute,
    growthEmailRoute,
    growthReferralsRoute,
    growthPartnersRoute,

    settingsControlsRoute,
    settingsUsersRoute,
    settingsAlertsRoute,
    settingsSystemRoute,
    settingsAuditRoute,
    settingsChangelogRoute,
  ]),
]);
